import { BehaviorSubject } from 'rxjs';

/**
 * A behavior subject which accepts partial updates
 */
export class StateSubject<T> extends BehaviorSubject<T> {

  private _previousValue: T;
  private _defaults: NonNullable<T>;

  constructor(defaults: NonNullable<{ [P in keyof T]: T[P] }>)
  {
    super(defaults);
    this._previousValue = defaults;
    this._defaults = defaults;
  }

  override next(value: Partial<T>): void
  {
    let updatedValue: T;

    if (this._previousValue != null && value != null)
    {
      updatedValue = { ...this._previousValue, ...value };
    }
    else if (value != null)
    {
      updatedValue = { ...this._defaults, ...value };
    }
    else
    {
      updatedValue = null as any;
    }

    super.next(updatedValue);
    this._previousValue = updatedValue;
  }

  clear()
  {
    super.next(null as any);
    this._previousValue = null as any;
  }

}
